import '../checkout/components/checkout_referral';
import '../checkout/components/checkout_summary';
import './components/auth';
import './index.scss';
import { MediaQuery } from 'utils/media_query';

const rows = document.querySelectorAll('.row');

if (MediaQuery.is('md')) {
  window.onload = () => {
    rows.forEach(row => {
      row.classList.add('row-flex');
    });
  };
}
